import React from 'react';

import './efficiency-chart.scss';

interface EfficiencyChartProps {
  value?: number;
}

function EfficiencyChart(props: EfficiencyChartProps) {
  const { value = 0 } = props;
  const widthPercentage = Math.max(0, value - 1) * 25;

  return (
    <div styleName="container">
      <div styleName={value === 0 ? 'background-grey' : 'background-green'}>
        <div style={{ width: `${widthPercentage}%` }} styleName="fill" />
        <div styleName="marks">
          {[1, 2, 3].map(number => (
            <span key={number} styleName="mark" />
          ))}
        </div>
      </div>
      <div styleName="series">
        {[1, 2, 3, 4, 5].map(number => (
          <span key={number} styleName="legend">
            {number}
          </span>
        ))}
      </div>

      {value !== 0 && (
        <div
          style={{
            left: `${widthPercentage}%` // scale is 1-5, so 4 possible values
          }}
          styleName="value"
        >
          {value}
          <span styleName="triangle" />
          <span styleName="value-mark" />
        </div>
      )}
    </div>
  );
}

export default EfficiencyChart;
